// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     document.body.classList.add("route-changing");

//     window.scrollTo(0, 0);

//     const timer = setTimeout(() => {
//       document.body.classList.remove("route-changing");
//     }, 420);

//     return () => clearTimeout(timer);
//   }, [pathname]);

//   return null;
// }


import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.add("route-changing");

    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });

    const timer = setTimeout(() => {
      document.body.classList.remove("route-changing");
    }, 450);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}